<template>
  <div clas="createRaces pa-3">
      <v-row>
        <v-col md="12" cols="12" sm="12" xs="12" class="text-center">
          <h2>
            <v-icon class="big_icon">create</v-icon>
           {{ $tc("dashboard.menu.createRace.title") }}
          </h2>
          <p>{{ $tc("dashboard.menu.createRace.subtitle") }}</p>
        </v-col>
      </v-row>
      <v-form ref="form" @submit.prevent="createRace">
        <v-stepper v-model="e1">
          <v-stepper-header>
            
            <v-stepper-step
              :complete="e1 > steps[0].step"
              step="1"
            >
              {{ steps[0].title }}
            </v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step
              :complete="e1 > steps[1].step"
              step="2"
            >
              {{ steps[1].title }}
            </v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step 
              :complete="e1 > steps[2].step"
              step="3"
            >
              {{ steps[2].title }}
            </v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step
              step="4"
            >
              {{ steps[3].title }}
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card
                class="mb-12"
                height="auto"
              >
                <v-row>
                  <v-col md="8" cols="12" sm="12" xs="12" offset-md="2" class="text-left">
                    <label>{{ $tc("dashboard.menu.createRace.event_label") }}</label>
                    <v-select v-if="eventItems.length > 1"
                      :items="eventItems"
                      item-text="name"
                      item-value="id"
                      v-model="form.event"
                      :rules="rules.event"
                      @change="changeEvent"
                      :no-data-text="$t('common.no_data')"
                    ></v-select>
                    <v-select v-else
                      :items="eventItems"
                      item-text="name"
                      item-value="id"
                      v-model="form.event"
                      :no-data-text="$t('common.no_data')"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-card>

              <v-btn v-if="eventItems.length > 1" color="primary" @click="form.event > 0 ? e1 = 2 : form.event = 0" >
                {{ $tc("dashboard.menu.createEvent.continue") }}
              </v-btn>
              <v-btn v-else color="primary" @click="createEvent">
                {{ $tc("dashboard.menu.createRace.create_an_event") }}
              </v-btn>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card
                class="mb-12"
                height="auto"
              >
                <v-row>
                  <v-col md="8" cols="12" sm="12" xs="12" offset-md="2" class="text-left">
                    <label>{{ $tc("dashboard.menu.createRace.series_label") }}</label>
                    <span>{{ $tc("dashboard.menu.createRace.series_span") }}</span>
                    <v-select
                      v-model="serie"
                      item-text="name"
                      item-value="id"
                      multiple
                      :items="seriesItems"
                      persistent-hint
                      :no-data-text="$t('common.no_data')"
                    ></v-select>
                    <v-dialog v-model="addSerieDialog" width="600">
                      <v-card>
                        <v-card-title>
                          <span class="headLine">{{ $t("dashboard.menu.createRace.add_new_series_title") }}</span>
                        </v-card-title>
                        <v-card-text>
                          <v-row>
                            <v-col md="12" class="text-left">
                              <v-label>
                                {{
                                $tc("dashboard.menu.createRace.add_serie_name_label")
                                }}
                              </v-label>
                              <v-text-field v-model="serieName"></v-text-field>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-actions class="fr">
                          <v-btn @click="addSerieDialog = false" color="darken-1" dark small>
                            {{ $t("dashboard.menu.createRace.close_label") }}
                          </v-btn>
                          <v-btn class="ml-12" @click="addSerieDialog = false" color="darken-1" dark small>
                            {{ $t("dashboard.menu.createRace.save_serie_label") }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-card>
              <v-card-actions class="justify-center">
                <v-btn color="primary" class="btn_next" @click="e1 = 1">
                  {{ $tc("dashboard.menu.createEvent.back") }}
                </v-btn>
                <v-btn color="primary" class="btn_next ml-12" @click="e1 = 3">
                  {{ $tc("dashboard.menu.createEvent.continue") }}
                </v-btn>
              </v-card-actions>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card
                class="mb-12"
                height="auto"
              >
                <v-row>
                  <v-col md="8" cols="12" sm="12" xs="12" offset-md="2" class="text-left">
                    <label>{{ $tc("dashboard.menu.createRace.classes_label") }}</label>
                    <span>{{ $tc("dashboard.menu.createRace.classes_span") }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="10" cols="12" sm="12" xs="12" offset-md="1" class="text-left">
                    <v-data-table
                      v-model="selected"
                      :headers="headers"
                      :items="items"
                      class="elevation-1"
                      sort-by="name"
                      :single-select="false"
                      show-select
                      item-key="name"
                      :footer-props="{
                        'items-per-page-options': [10, 20, 30, 50,-1],
                        'items-per-page-text': $t('dataTable.rowsPerPageText'),
                        'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                      }"
                      :items-per-page="-1"
                      :headerProps="{
                        'sort-by-text': $t('dataTable.sortByText')
                      }"
                      :no-data-text="$t('dataTable.noDataText')"
                    >            
                    <template v-slot:item="props">
                      <tr>
                        <td><v-checkbox :input-value="props.isSelected" @change="props.select($event)"></v-checkbox></td>
                        <td>{{ props.item.name }}</td>
                        <td>${{ props.item.addedFee }}</td>
                        <td>{{ props.item.registered }}</td>
                        <td>{{ props.item.classGroup }}</td>
                        <td>{{ props.item.startTime }}</td>
                        <td>
                          <v-btn icon @click="editItem(props.item)">
                            <v-icon>fa-pencil-alt</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-card>

              <v-card-actions class="justify-center">
                <v-btn color="primary" class="btn_next" @click="e1 = 2">
                  {{ $tc("dashboard.menu.createEvent.back") }}
                </v-btn>
                <v-btn color="primary" class="btn_next ml-12" @click="selected.length > 0 ? e1 = 4 : el = 3">
                  {{ $tc("dashboard.menu.createEvent.continue") }}
                </v-btn>
              </v-card-actions>
            </v-stepper-content>

            <v-stepper-content step="4">
              <v-card
                class="mb-12"
                height="auto"
              >
                <v-row v-if="form.event > 0">
                  <v-col md="8" cols="12" sm="12" xs="12" offset-md="2" class="text-left">
                    <label>{{ $tc("dashboard.menu.createRace.scoring_label") }}</label>
                    <v-select
                      :items="scoringItems"
                      item-text="name"
                      item-value="id"
                      v-model="scoring"
                      @change="changeTypeScoring"
                      :no-data-text="$t('common.no_data')"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row v-if="subModeSelect">
                  <v-col md="6" offset-md="3" class="text-left">
                    <label>{{ $tc("dashboard.menu.createRace.scoring_label") }}</label>
                    <v-select 
                      :items="scoring2Items" 
                      item-text="val" 
                      item-value="id" 
                      v-model="scoring2"
                      :no-data-text="$t('common.no_data')"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row v-if="commonSetup">
                  <v-col md="6" offset-md="3" class="text-left">
                    <label>
                      {{ $tc("dashboard.menu.createRace.race_label") }}
                      <span class="ob">*</span>
                    </label>
                    <v-text-field
                      :placeholder="$tc('dashboard.menu.createRace.race_label')"
                      v-model="form.race"
                      :rules="rules.race"
                    ></v-text-field>
                  </v-col>
                  <v-col md="6" offset-md="3" class="text-left" v-if="scoring2 != 1">
                    <v-row>
                      <v-col md="12" class="pb-0 pt-0">
                        <label>
                          {{ $tc("dashboard.menu.createRace.track_label") }}
                          <span class="ob">*</span>
                        </label>
                      </v-col>
                      <v-col md="8" class="pt-0">
                        <v-text-field placeholder="10" v-model="form.track" :rules="rules.track"></v-text-field>
                      </v-col>
                      <v-col md="4" class="pt-0">
                        <v-select 
                          v-model="trackMeasure" 
                          :items="trackMeasureItems"
                          :no-data-text="$t('common.no_data')"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row v-if="rtlSetup">
                  <v-col md="6" offset-md="3" class="text-left">
                    <label>
                      {{ $tc("dashboard.menu.createRace.check_label") }}
                      <span class="ob">*</span>
                    </label>
                    <v-text-field
                      :placeholder="$tc('dashboard.menu.createRace.check_label')"
                      v-model="form.checkCount"
                      :rules="rules.checkCount"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="nfcSetup">
                  <v-col md="6" offset-md="3" class="text-left">
                    <label>
                      {{ countTitle }}
                      <span class="ob">*</span>
                    </label>
                    <v-text-field
                      :placeholder="$tc('dashboard.menu.createRace.check_label')"
                      v-model="form.checkCount"
                      :rules="rules.checkCount"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="checktocheck">
                  <v-col md="6" offset-md="3" class="text-center">
                    <label>
                      {{
                      $tc("dashboard.menu.createRace.show_penalty_column_label")
                      }}
                    </label>
                    <v-btn-toggle mandatory v-model="penaltyColumn">
                      <v-btn>
                        <v-icon class="ob">cancel</v-icon>
                        {{ $tc("dashboard.menu.createRace.no") }}
                      </v-btn>
                      <v-btn>
                        <v-icon class="suc">done</v-icon>
                        {{ $tc("dashboard.menu.createRace.yes") }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                  <v-col md="6" offset-md="3">
                    <span class="db">
                      <v-icon>info</v-icon>
                      {{ $tc("dashboard.menu.createRace.please_setup_msg") }}
                    </span>
                    <span v-if="errorCheck" class="db ob text-center mt10">
                      {{
                      errorCheckMsg
                      }}
                    </span>
                    <div>
                      <div v-for="chk in checkPoints" :key="chk.from" class="box_item">
                        <span v-if="chk.transit == 'Yes'">
                          {{
                          $tc("dashboard.menu.createRace.transit_points_label")
                          }}:
                        </span>
                        {{ $tc("dashboard.menu.createRace.check_points_label") }}
                        {{ chk.from }} -
                        {{ $tc("dashboard.menu.createRace.check_points_label") }}
                        {{ chk.to }} ({{ chk.length }} {{ chk.track }})
                        <v-icon @click="deleteCheckPoint(chk)">delete</v-icon>
                      </div>
                    </div>

                    <template>
                      <v-btn class="btn mt-6" @click="createChecks">
                        {{ message_btn }}
                      </v-btn>
                      <v-dialog v-model="addCheckScored" width="600">
                        <v-card>
                          <v-card-title>
                            <span class="headLine">
                              {{ $t("dashboard.menu.createRace.modal_select_checks_title") }}
                            </span>
                          </v-card-title>
                          <v-card-text>
                            <v-row>
                              <v-col md="12" class="text-left">
                                <label>
                                  {{ $tc("dashboard.menu.createRace.modal_select_checks_subtitle") }}
                                </label>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col md="2" class="text-left">
                                <label>
                                  {{ $tc("dashboard.menu.createRace.modal_select_check_label") }}
                                </label>
                              </v-col>
                              <v-col md="4" class="text-left">
                                <v-select
                                  v-model="checkPoint"
                                  :items="checkCountItems"
                                  item-disabled="sel"
                                  item-value="val"
                                  item-text="val"
                                  @change="selectCheckPoint"
                                  :no-data-text="$t('common.no_data')"
                                ></v-select>
                              </v-col>
                              <v-col md="3" class="text-left">
                                <label>
                                  {{ $tc("dashboard.menu.createRace.modal_to_check") }}
                                </label>
                              </v-col>
                              <v-col md="3" class="text-left ob">
                                {{ checkPointTo }}
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col md="2" class="text-left">
                                <label>
                                  {{ $tc("dashboard.menu.createRace.modal_length") }}
                                </label>
                              </v-col>
                              <v-col md="4" class="text-left">
                                <v-text-field placeholder="1" type="number" v-model="lengthPoint"></v-text-field>
                              </v-col>
                              <v-col md="3" class="text-left">
                                <v-select 
                                  :items="trackMeasureItems" 
                                  v-model="trackPoint"
                                  :no-data-text="$t('common.no_data')"
                                ></v-select>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col md="2" class="text-left">
                                <label>
                                  {{ $tc("dashboard.menu.createRace.modal_is_transit") }}
                                </label>
                              </v-col>
                              <v-col md="4" class="text-left">
                                <v-select 
                                  :items="itemsYesNo" 
                                  v-model="transitPoint"
                                  :no-data-text="$t('common.no_data')"
                                ></v-select>
                              </v-col>
                            </v-row>
                          </v-card-text>
                          <v-card-actions class="fr">
                            <v-btn
                              @click="addCheckScored = false"
                              color="darken-1"
                              dark small
                            >{{ $tc("dashboard.menu.createRace.close_label") }}</v-btn>
                            <v-btn
                              class="ml-12"
                              @click="addCheckPoint"
                              color="darken-1"
                              dark small
                            >{{ $tc("dashboard.menu.createRace.add_label") }}</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </template>
                  </v-col>
                </v-row>
                <v-row v-if="marathon">
                  <v-col md="6" offset-md="3">
                    <span class="db">
                      <v-icon>info</v-icon>
                      {{ $tc("dashboard.menu.createRace.please_setup_msg") }}
                    </span>
                    <span v-if="errorCheck" class="db ob text-center mt10">
                      {{ errorCheckMsg }}
                    </span>
                    <div>
                      <div v-for="sec in setupSectionsItems" :key="sec.length" class="box_item">
                        {{ $tc("dashboard.menu.createRace.section_label") }}
                        {{ sec.id }} ({{ sec.length }} {{ sec.track }})
                        <v-icon @click="deleteSection(sec)">delete</v-icon>
                      </div>
                    </div>
                    <template v-if="marathon">
                      <v-btn class="btn mt-6" @click="createSection" type="button">
                        {{ message_btn }}
                      </v-btn>
                      <!-- Dialog Setup Sections -->
                      <v-dialog v-model="setupSectionsB" width="600">
                        <v-card>
                          <v-card-title>
                            <span class="headLine">
                              {{ $t("dashboard.menu.createRace.modal_section_title") }}
                            </span>
                          </v-card-title>
                          <v-card-text>
                            <v-row>
                              <v-col md="12" class="text-left">
                                <label>
                                  {{ $t("dashboard.menu.createRace.modal_section_subtitle") }}
                                </label>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col md="2" class="text-left">
                                <label>
                                  {{ $t("dashboard.menu.createRace.modal_length") }}
                                </label>
                              </v-col>
                              <v-col md="4" class="text-left">
                                <v-text-field placeholder="1" type="number" v-model="lengthSection"></v-text-field>
                              </v-col>
                              <v-col md="3" class="text-left">
                                <v-select 
                                  :items="trackMeasureItems" 
                                  v-model="trackSection"
                                  :no-data-text="$t('common.no_data')"
                                ></v-select>
                              </v-col>
                            </v-row>
                          </v-card-text>
                          <v-card-actions class="fr">
                            <v-btn
                              @click="setupSectionsB = false"
                              color="darken-1"
                              dark small
                            >{{ $t("dashboard.menu.createRace.close_label") }}</v-btn>
                            <v-btn
                              class="ml-12"
                              @click="addSetupSection"
                              color="darken-1"
                              dark small
                            >{{ $t("dashboard.menu.createRace.add_label") }}</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </template>
                  </v-col>
                </v-row>
                <v-row v-if="lapsmode">
                  <v-col md="6" offset-md="3">
                    <label>
                      <v-icon>info&nbsp;</v-icon>
                      {{ $tc("dashboard.menu.createRace.scoring_option_laps_span") }}
                    </label>
                  </v-col>
                  <v-col md="6" offset-md="3">
                    <label>
                      {{ $tc("dashboard.menu.createRace.past_midn_label") }}
                    </label>
                    <v-btn-toggle mandatory v-model="multi">
                      <v-btn :value="1">
                        <v-icon class="suc">done</v-icon>
                        {{ $tc("dashboard.menu.createRace.yes") }}
                      </v-btn>
                      <v-btn :value="0">
                        <v-icon class="ob">cancel</v-icon>
                        {{ $tc("dashboard.menu.createRace.no") }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                </v-row>
                <v-row v-if="enduro">
                  <v-col md="6" offset-md="3" class="text-center">
                    <label>
                      {{ $tc("dashboard.menu.createRace.show_penalty_column_label") }}
                    </label>
                    <v-btn-toggle mandatory v-model="penaltyColumn">
                      <v-btn>
                        <v-icon class="ob">cancel</v-icon>
                        {{ $tc("dashboard.menu.createRace.no") }}
                      </v-btn>
                      <v-btn>
                        <v-icon class="suc">done</v-icon>
                        {{ $tc("dashboard.menu.createRace.yes") }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                  <v-col md="6" offset-md="3" class="text-center">
                    <h3>{{ $tc("dashboard.menu.createRace.time_settings_label") }}</h3>
                  </v-col>
                  <v-col md="3" offset-md="3" class="text-left">
                    <label>
                      {{ $tc("dashboard.menu.createRace.start_time_label") }}
                      <span class="ob">*</span>
                    </label>

                    <v-menu
                      v-model="endDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="form.starTime"
                          :rules="rules.starTime"
                          v-on="on"
                          prepend-icon="timer"
                          :value="fromStartDateDisp"
                          readonly
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        locale="en-in"
                        v-model="form.starTime"
                        format="24hr"
                        no-title
                        use-seconds
                        @input="endDateMenu = false"
                      ></v-time-picker>
                    </v-menu>
                  </v-col>
                  <v-col md="3" class="text-left">
                    <label>
                      {{ $tc("dashboard.menu.createRace.duration_label") }}
                      <span class="ob">*</span>
                    </label>
                    <v-text-field v-model="form.duration" :rules="rules.duration" type="number"></v-text-field>
                  </v-col>
                  <v-col md="6" offset-md="3" class="text-center">
                    <h3>{{ $tc("dashboard.menu.createRace.section_configuration_label") }}</h3>
                    <p>{{ $tc("dashboard.menu.createRace.section_configuration_span") }}</p>
                  </v-col>
                  <v-col md="6" offset-md="3">
                    <v-card class="mh-120">
                      <v-card-text>
                        <v-row v-for="(input, k) in inoutInputs" :key="k">
                          <v-col md="2" class="text-center">
                            <label>
                              {{ $tc("dashboard.menu.createRace.in_label") }}&nbsp;-&nbsp;{{ $tc("dashboard.menu.createRace.out_label") }}
                            </label>
                            <label>{{ input.inNum }}&nbsp;-&nbsp;{{ input.outNum }}</label>
                          </v-col>
                          <v-col md="4">
                            <v-label>
                              {{ $tc("dashboard.menu.createRace.distance_label") }}
                            </v-label>
                            <v-text-field v-model="input.in"></v-text-field>
                          </v-col>
                          <v-col md="4">
                            <v-label>
                              {{ $tc("dashboard.menu.createRace.repeat_limit_label") }}
                            </v-label>
                            <v-text-field v-model="input.out"></v-text-field>
                          </v-col>
                          <v-col
                            md="2"
                            v-if="inoutInputs.length > 1 && k == inoutInputs.length - 1"
                            class="text-left"
                          >
                            <v-btn @click="removeInOut(k)" class="rem_btn">
                              <v-icon>cancel</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-actions class="justify-center">
                        <v-btn @click="addInOut">
                          <v-icon>add_circle</v-icon>
                          {{ $tc("dashboard.menu.createRace.add_label") }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
               <v-card-actions class="justify-center">
                <v-btn color="primary" class="btn_next" @click="e1 = 3">
                  {{ $tc("dashboard.menu.createEvent.back") }}
                </v-btn>
                <v-btn color="primary" class="btn_next ml-12" type="submit">
                  {{ $tc("dashboard.menu.createEvent.continue") }}
                </v-btn>
              </v-card-actions>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-form>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import { YES_NO_OPTIONS } from "@/constants/selectOptions.js";

export default {
  mixins: [apiCalls],
  name: "CreateRaces",
  data() {
    const raceForm = Object.freeze({
      race: "",
      track: 0,
      checkCount: 0,
      section_count: 0,
      starTime: "",
      duration: "",
      event: parseInt(this.$route.params.id) ///Change
    });
    return {
      items: [],
      selected: [],
      form: Object.assign({}, raceForm),
      e1: 1,
      errorCheck: false,
      raceForm,
      addSerieDialog: false,
      addCheckScored: false,
      commonSetup: false,
      rtlSetup: false,
      nfcSetup: false,
      marathon: false,
      checktocheck: false,
      lapsmode: false,
      enduro: false,
      subModeSelect: false,
      serieName: "",
      eventItems: [],
      classe: [],
      serie: [],
      seriesItems: [],
      classesItems: [],
      scoringItems: [],
      scoring2: 0,
      inoutInputs: [
        {
          inNum: 1,
          outNum: 2,
          in: "",
          out: ""
        }
      ],
      checkCountItems: [],
      checkPoint: "",
      checkPointTo: "",
      checkPoints: [],
      transitPoint: "",
      lengthPoint: "",
      errorCheckMsg: "",
      setupSectionsB: false,
      setupSectionsItems: [],
      lengthSection: "",
      trackSection: "",
      countTitle: "",
      endDateMenu: false,
      startD: "",
      penaltyColumn: "",
      toggle_exclusive: 1,
      multi: 0
    };
  },
  mounted() {
    //Consultar ID URL
    this.getAllSeries();
    this.getAllClasses(this.form.event);
    this.getScoreModes();
    this.getAllEvents();
  },
  updated(){

    let arr = [];

    for(var i=0; i<this.selected.length; i++){
      arr.push(this.selected[i].id);
    }     

    this.classe = arr;
  },
  methods: {
    editItem(item) {
      this.$router.push({
        path: `/eventDetails/${this.form.event}/eventClasses/edit/${item.id}`,
        query: { createRace: true }
      });
    },
    async getScoreModes() {
      var response = await this.api(
        "get",
        "/api/v1/promoter/createRace/getScoreModes"
      );

      response.message.forEach(value => {
        if (value.systemId == 2)
          this.scoringItems.push({
            id: value.id,
            name: value.mode
          });
      });
    },
    createEvent(){
        this.$router.push({
          name: 'EventCreate',
        });
    },
    async getAllSeries() {
      var response = await this.api(
        "get",
        "/api/v1/promoter/createRace/getAllSeries"
      );

      response.message.forEach(value => {
        this.seriesItems.push({
          id: value.id,
          name: value.seriesName
        });
      });
    },
    async getAllClasses(eventId) {
      var response = await this.api(
        "get",
        "/api/v1/promoter/createRace/getEventClasses/" + eventId
      );

      this.items = response.message;
      this.classesItems = [];
      Object.entries(response.message).forEach(([value]) => {
        this.classesItems.push({
          id: value.id,
          name: value.name
        });
      });
      this.selected = this.items
    },
    async getAllEvents() {
      var response = await this.api(
        "get",
        "/api/v1/users/current/getUserEventList/curE"
      );
      if(response.message.length>0){
        this.eventItems.push({
            id: 0,
            name: this.$t("dashboard.menu.createRace.please_select_label")
          });
        response.message.forEach(element => {
          this.eventItems.push({
            id: element.id,
            name: element.name
          });
        });
      }else{
          this.eventItems.push({
            id: 0,
            name: this.$t("dashboard.menu.createRace.not_events")
          });
          this.form.event = 0
      }
    },
    changeEvent() {
      if (this.form.event > 0){
        this.getAllClasses(this.form.event);
        this.serie = []
        this.selected = []
      } 
    },
    createSection() {
      this.errorCheck = false;
      this.setupSectionsB = false;
      if (this.form.checkCount > 0) {
        if (this.setupSectionsItems.length == this.form.checkCount) {
          this.errorCheck = true;
          this.errorCheckMsg = this.$t(
            "dashboard.menu.createRace.completed_check_points_msg"
          );
        } else {
          this.setupSectionsB = true;
        }
      } else {
        this.errorCheckMsg = this.$t(
          "dashboard.menu.createRace.check_to_check_error"
        );
        this.errorCheck = true;
      }
    },
    createChecks() {
      this.errorCheck = false;
      this.addCheckScored = false;
      if (this.checkCountItems.length == 0) {
        for (let i = 0; i < this.form.checkCount - 1; i++) {
          this.checkCountItems.push({
            val: i + 1,
            sel: false
          });
        }
      }
      if (this.form.checkCount > 0) {
        if (this.checkCountItems.length == this.checkPoints.length) {
          this.errorCheck = true;
          this.errorCheckMsg = this.$t(
            "dashboard.menu.createRace.completed_check_points_msg"
          );
        } else {
          this.addCheckScored = true;
        }
      } else {
        this.errorCheckMsg = this.$t(
          "dashboard.menu.createRace.check_to_check_error"
        );
        this.errorCheck = true;
      }
    },
    selectCheckPoint() {
      this.checkPointTo = this.checkPoint + 1;
    },
    addSetupSection() {
      let pos = this.setupSectionsItems.length;
      this.setupSectionsItems.push({
        id: pos + 1,
        length: this.lengthSection,
        track: this.trackSection
      });
      this.setupSectionsB = false;
    },
    addCheckPoint() {
      this.checkCountItems.filter(x => {
        if (x.val == this.checkPoint) x.sel = true;
      });
      this.checkPoints.push({
        from: this.checkPoint,
        to: this.checkPointTo,
        length: this.lengthPoint,
        track: this.trackPoint,
        transit: this.transitPoint
      });
      this.addCheckScored = false;
      this.checkPoint = "";
      this.checkPointTo = "";
      this.lengthPoint = "";
      this.transitPoint = "";
    },
    deleteCheckPoint(chk) {
      let reg = this.checkPoints.indexOf(chk);
      this.checkPoints.splice(reg, 1);
      this.checkCountItems.filter(x => {
        if (x.val == chk.from) {
          x.sel = false;
        }
      });
    },
    deleteSection(sec) {
      let reg = this.setupSectionsItems.indexOf(sec);
      this.setupSectionsItems.splice(reg, 1);
    },
    async createRace() {
      if(this.$refs.form.validate()){
        //create Race
        if(this.form.starTime==''){
          this.form.starTime='00:00:00'
        }
        if(this.penaltyColumn==''){
          this.penaltyColumn = 0
        }
        
        let data = {
          raceName: this.form.race, //Required
          eventId: this.form.event, //Required
          eventMode: this.scoring, //Optional
          eventSubMode: this.scoring2, //Optional,
          //trackImage: "", //Optional,
          trackLen: this.form.track + "" + this.trackMeasure, //Required
          checks: this.form.checkCount, //Required,
          sections: this.checkPoints, //Required
          systemId: 2, //Required,
          //
          //firstMinute: "", //Seconds Optional
          //nextMinute: "", //Seconds Optional,
          //hourOut: "", //Minute optional,
          keyTimeFlag: 0, // Required
          readerFlag: 0, // INt required
          earlyAtOutFlag: 0, // Required
          timekeeper: 0, //Required
          sprint: 0, //Required
          //
          startTime: this.form.starTime, //Date reuired
          duration: this.form.duration, // Optional
          raceClasses: this.classe, //Required
          seriesClasses: this.serie, //required
          penaltyColumn: this.penaltyColumn, // required
          multi: 0 //Required
        };
        
        const response = await this.postApi("/api/v1/promoter/createRace/", data);

        if (response.success == 1) {
          let path = "/raceList" ;
          this.$router.push({
            path: path,
          });
        }
      }
    },
    addInOut() {
      this.inoutInputs.push({
        inNum: this.inoutInputs[this.inoutInputs.length - 1].inNum + 2,
        outNum: this.inoutInputs[this.inoutInputs.length - 1].outNum + 2,
        in: "",
        out: ""
      });
    },
    removeInOut(index) {
      this.inoutInputs.splice(index, 1);
    },
    changeTypeScoring() {
      this.commonSetup = false;
      this.rtlSetup = false;
      this.nfcSetup = false;
      this.marathon = false;
      this.checktocheck = false;
      this.lapsmode = false;
      this.enduro = false;
      this.subModeSelect = false;
      switch (this.scoring) {
        case 0:
          break;
        case 1:
          this.commonSetup = true;
          break;
        case 2:
          this.commonSetup = true;
          this.rtlSetup = true;
          break;
        case 4:
          this.commonSetup = true;
          this.nfcSetup = true;
          this.checktocheck = true;
          this.message_btn = this.$t(
            "dashboard.menu.createRace.button_msg_simple"
          );
          this.countTitle = this.$t("dashboard.menu.createRace.check_label");
          break;
        case 5:
          this.commonSetup = true;
          this.nfcSetup = true;
          this.marathon = true;
          this.message_btn = this.$t(
            "dashboard.menu.createRace.button_msg_marathon"
          );
          this.countTitle = this.$t("dashboard.menu.createRace.section_label");
          break;
        case 7:
          this.commonSetup = true;
          this.nfcSetup = true;
          this.checktocheck = true;
          break;
        case 8:
          this.commonSetup = true;
          this.enduro = true;
          break;
        case 6:
        case 9:
          this.commonSetup = true;
          this.lapsmode = true;
          break;
        case 10:
          this.commonSetup = true;
          this.subModeSelect = true;
          break;
      }
    }
  },
  computed: {
    steps() {
      return [
        {
          nro: 1,
          step: 1,
          title: this.$t("page.createRace.steps.event")
        }, 
        {
          nro: 2,
          step: 2,
          title: this.$t("page.createRace.steps.series")
        },    
        {
          nro: 3,
          step: 3,
          title: this.$t("page.createRace.steps.classes")
        },    
        {
          nro: 4,
          step: 4,
          title: this.$t("page.createRace.steps.scoring-type")
        }
      ];
    },
    formIsValid() {
      //validates
      let valid = false;
      switch (this.scoring) {
        case 4:
        case 5:
          if (
            this.form.race &&
            this.form.track &&
            this.form.checkCount &&
            this.form.event
          )
            valid = true;
          break;
        case 6:
        case 9:
          if (this.form.race && this.form.track && this.form.event)
            valid = true;
          break;
        case 8:
          if (
            this.form.race &&
            this.form.track &&
            this.form.starTime &&
            this.form.duration &&
            this.form.event
          )
            valid = true;
          break;
        case 10:
          if (this.scoring2 == 1 && this.form.race && this.form.event)
            valid = true;
          else if (
            this.scoring2 != 1 &&
            this.form.race &&
            this.form.track &&
            this.form.event
          )
            valid = true;
      }
      return valid;
    },
    fromStartDateDisp() {
      return this.startD;
    },
    headers() {
      return [
          {
            text: this.$t("dashboard.menu.createRace.class_name"),
            align: 'start',
            sortable: true,
            value: 'name',
          },
          {
            text: this.$t("dashboard.menu.createRace.added_registration_fee"),
            value: "addedFee",
            sortable: true,
          },
          { text: this.$t("dashboard.menu.createRace.registered"), 
            value: "registered",
            sortable: true,
          },
          { text: this.$t("dashboard.menu.createRace.group"),
            value: "classGroup",
            sortable: true,
          },
          { text: this.$t("dashboard.menu.createRace.start_time"), 
            value: "startTime",
            sortable: true,
          },
          { text: this.$t("dashboard.menu.createRace.edit"), value: '', sortable: false}
      ];
    },
    rules() {
      return {
        event: [
          val => val > 0 || this.$t("dashboard.menu.createRace.event_required")
        ],
        race: [
          val => (val || "").length > 0 || this.$t("dashboard.menu.createRace.race_required")
        ],
        track: [
          val => val > 0 || this.$t("dashboard.menu.createRace.track_required")
        ],
        checkCount: [
          val => val > 0 || this.$t("dashboard.menu.createRace.check_required")
        ],
        section_count: [
          val => val > 0 || this.$t("dashboard.menu.createRace.section_count_required")
        ],
        starTime: [
          val => (val || "").length > 0 || this.$t("dashboard.menu.createRace.starTime_required")
        ],
        duration: [
          val => val > 0 || this.$t("dashboard.menu.createRace.duration_required")
        ]
      };
    },
    itemsYesNo() { return YES_NO_OPTIONS(this); }, 
    trackMeasure() { return this.$t("dashboard.menu.createRace.track_measure_km"); },
    trackMeasureItems() { 
      return [
        this.$t("dashboard.menu.createRace.track_measure_km"),
        this.$t("dashboard.menu.createRace.track_measure_ml")
      ];
    },
    message_btn() { return this.$t("dashboard.menu.createRace.button_msg_simple"); },
    scoring() {
      return {
        id: 0,
        name: this.$t("dashboard.menu.createRace.please_select_label")
      };
    },
    scoring2Items() {
      return [
        {
          id: 0,
          val: this.$t("dashboard.menu.createRace.scoring2_option_restart")
        },
        {
          id: 1,
          val: this.$t("dashboard.menu.createRace.scoring2_option_reliability")
        },
        {
          id: 2,
          val: this.$t("dashboard.menu.createRace.scoring2_option_timekeeper")
        }
      ];
    },
    trackPoint() { return this.$t("dashboard.menu.createRace.track_measure_km"); },
  }
};
</script>

<style>
.big_icon {
  font-size: 24px !important;
  color: #000 !important;
}
.createRaces .v-text-field {
  padding: 0;
  margin: 0;
}

label {
  display: block;
}
.btn {
  border: solid 1px #ccc;
  padding: 10px;
  border-radius: 4px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.btn_add_serie {
  float: right;
  margin-top: -10px;
}
.fr {
  float: right;
}
.mh-120 {
  min-height: 120px;
}
.db {
  display: block;
}
.ob {
  color: red !important;
}
.suc {
  color: green !important;
}
.rem_btn {
  border-radius: 0;
  border: 0;
  box-shadow: none;
  margin-top: 17px;
}
.box_item {
  width: max-content;
  border: solid 1px #ccc;
  border-radius: 8px;
  padding-left: 5px;
  padding-right: 5px;
  font-size: 13px;
  display: inline-block;
  margin-right: 5px;
  margin-top: 10px;
}
.mt10 {
  margin-top: 10px;
}
.v-input--selection-controls {
    margin-top: 3px !important;
}
.v-simple-checkbox {
  margin-top: 12px;
}
</style>
